import { render, staticRenderFns } from "./productBox.vue?vue&type=template&id=2d352570&scoped=true&"
import script from "./productBox.vue?vue&type=script&lang=js&"
export * from "./productBox.vue?vue&type=script&lang=js&"
import style0 from "./productBox.vue?vue&type=style&index=0&id=2d352570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d352570",
  null
  
)

export default component.exports